/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';

import { useLocation } from 'react-router-dom';
import TopNavigation from '../../organisms/TopNavigation';
import SideNav from '../../organisms/SideNav';
import BannerBlock from '../../organisms/BannerBlock';
import { Content } from './PageTemplate.styles';
import UserTemplate from '../UserTemplate';
import BannerTop from '../../organisms/Banner';
import KickOffBanner from '../../organisms/KickOffBanner';
import { AuthContext } from '../../../context/authContext';
import HeroSection from '../../organisms/HeroSection';

function PageTemplate({ title, children, showTemplate }) {
  const location = useLocation();
  return (
    <>
      {showTemplate ? (
        <Content>
          <BannerTop />
          <TopNavigation title={title ?? location?.pathname.split('/')[1]} />
          <SideNav />
          {/* <BannerBlock profilePage={view === 'profile'} /> */}
          <HeroSection />
          {children}
        </Content>
      ) : (
        <UserTemplate>{children}</UserTemplate>
      )}
    </>
  );
}

export default PageTemplate;
